import $ from 'jquery'
import axios from 'axios'
import auth from './auth'
import $root from './root'
import progress from './nprogress'

const api = axios.create({
  // baseURL: 'https://api.vendoscope.pro/',
  baseURL: '/api/admin/',
  paramsSerializer: $.param,
  headers: {
    common: {
      // 'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    },
  },
})
progress.use(api)

api.interceptors.response.use(response => {
  // Update release
  if (response && response.headers && response.headers.release) {
    if ($root) {
      $root.release = response.headers.release
    }
  }
  return response
}, error => {

  // Go to login when api returns Unauthenticated response
  // for any request except oauth login
  if (error.response && error.response.status === 401) {
    auth.afterLogout()

    return Promise.reject(error)
  }

  // The request was made and the server responded with a status code that falls out of the range of 2xx
  // if (error.response) {
  //   // We've catch the Upstream error! Or something not found in Upstream service
  //   if (error.response.data.error === 'upstream_error' && error.response.status === 502) {
  //     $root.showAlert(error.response.data.message)
  //   } else if (error.response.data.error === 'upstream_not_found' && error.response.status === 404) {
  //     $root.showAlert(error.response.data.message)
  //   } else {
  //     // Or something really bad happened from our Proxy..
  //     $root.showAlert('Ошибка при выполнении запроса')
  //   }
  //
  //   return Promise.reject(error)
  // } else if (error.request) {
  //   // The request was made but no response was received
  //   $root.showAlert('Ошибка при выполнении запроса')
  // } else if (error.response === undefined && error.message === 'Network Error') {
  //   // No internet connection
  //   $root.showAlert('Ошибка при выполнении запроса')
  // } else {
  //   // Something happened in setting up the request that triggered an Error
  //   $root.showAlert('Ошибка при выполнении запроса')
  // }

  return Promise.reject(error)
})

export default api



// WEBPACK FOOTER //
// ./resources/assets/js/api.js